import themeWareBeeDark from '../themeWareBeeDark';

export type TW = typeof themeWareBeeDark;

export const TwTheme: TW = themeWareBeeDark;
